import { render } from "./BandejasTab.vue?vue&type=template&id=b5e3b084&scoped=true"
import script from "./BandejasTab.vue?vue&type=script&lang=js"
export * from "./BandejasTab.vue?vue&type=script&lang=js"

import "./BandejasTab.vue?vue&type=style&index=0&id=b5e3b084&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5e3b084"]])

export default __exports__